import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { SelectWrapper } from "../../Common/Ui/SelectWrapper";
import { appAxios } from "../../../axios/axios";
import {
  IDepartmentList,
  ISelectedDeskphoneOption,
} from "../../../interfaces/department.interface";
import { IUserData } from "../../../interfaces/userData.interface";
import { toast } from "react-toastify";
import { IdeskPhone } from "../../../interfaces/enquiry.interface";
import { LoadingButton } from "../../Common/Ui/LoadingButton";
import { Link, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";

export const DeskphoneOptions: React.FC<{
  index: number;
  deskphone: IdeskPhone;
  staffArr: IUserData[];
  departmentArr: IDepartmentList[];
}> = (props) => {
  const [radioOptionState, setRadioOptionState] = useState({
    isDepartmentChecked: false,
    isStaffChecked: false,
  });

  const [selectedDepartment, setSelectedDepartment] = useState<{
    value: number;
    label: string;
  }>();

  const [selectedStaff, setSelectedStaff] = useState<{
    value: string;
    label: string;
  }>();

  const [deskphoneAssignLoading, setDeskphoneAssignLoading] = useState(false);

  const [staffNotExsistModal, setStaffNotExsistModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const deskphoneAssignSave = async () => {
    try {
      setDeskphoneAssignLoading(true);
      let deskphoneAssignData: ISelectedDeskphoneOption | null = null;
      if (radioOptionState.isDepartmentChecked) {
        deskphoneAssignData = {
          type: "department",
          departmentId: selectedDepartment?.value || null,
          id: props.deskphone.id,
        };
      }

      if (radioOptionState.isStaffChecked) {
        deskphoneAssignData = {
          type: "staff",
          staffUUID: selectedStaff?.value || null,
          id: props.deskphone.id,
        };
      }

      const assignResponse = await appAxios.post(
        "/staff/caller-desk/deskPhoneAssign",
        deskphoneAssignData
      );

      if (assignResponse.data.success) {
        if (assignResponse.data.result.isStaffExsistInDepartment === false) {
          setStaffNotExsistModal(true);
        } else {
          toast.success("Deskphone assigned");
        }
      }
    } catch (error: any) {
      toast.error(error.data?.errorMessage || "Unable to assign deskphone");
    }
    setDeskphoneAssignLoading(false);
  };

  const setSavedData = () => {
    if (props.deskphone.departmentId) {
      setSelectedDepartment({
        label: props.deskphone.deskPhoneName,
        value: props.deskphone.departmentId,
      });
    }

    // this work will be done for multi select staff
    // if (props.deskphone.deskphoneStaffMapping?.length) {
    // const staffData = props.deskphone.deskphoneStaffMapping.map((staff) => {
    //   const staffDetails = props.staffArr.find(
    //     (st) => st.uuid === staff.staffUserUUID
    //   );
    //   const primaryPhone = staffDetails?.phoneNumbers.find(
    //     (phone) => phone.label === "Primary"
    //   );
    //   const phoneCode = primaryPhone?.phoneCountryCode || "";
    //   const phone = primaryPhone?.phoneNumber || "";
    //   return {
    //     label: `${staffDetails?.firstName} ${staffDetails?.lastName}(${staffDetails?.email} ${phoneCode} ${phone})`,
    //     value: staff.staffUserUUID,
    //   };
    // });
    // setSelectedStaff(staffData);
    // }

    if (props.deskphone.staffUserUUID) {
      const staff = props.staffArr.find(
        (st) => st.uuid === props.deskphone.staffUserUUID
      );
      const primaryPhone = staff?.phoneNumbers.find(
        (phone) => phone.label === "Primary"
      );
      const phoneCode = primaryPhone?.phoneCountryCode || "";
      const phone = primaryPhone?.phoneNumber || "";
      setSelectedStaff({
        label: `${staff?.firstName} ${staff?.lastName}(${staff?.email} ${phoneCode} ${phone})`,
        value: staff?.uuid || "",
      });
    }
  };

  useEffect(() => {
    setSavedData();
  }, [props.staffArr]);

  useEffect(() => {
    setRadioOptionState({
      isDepartmentChecked: Boolean(props.deskphone.departmentId),
      // isStaffChecked: Boolean(props.deskphone.deskphoneStaffMapping?.length),
      isStaffChecked: Boolean(props.deskphone.staffUserUUID),
    });
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <Form.Check
            className="small"
            type="radio"
            label="Department"
            name={`departmentStaffRadio-${props.index}`}
            id={`department-${props.index}`}
            onChange={(e) => {
              setRadioOptionState({
                isDepartmentChecked: e.target.checked,
                isStaffChecked: false,
              });
            }}
            checked={radioOptionState.isDepartmentChecked}
          />
          <Form.Check
            className="small"
            type="radio"
            label="Staff"
            name={`departmentStaffRadio-${props.index}`}
            id={`staff-${props.index}`}
            onChange={(e) => {
              setRadioOptionState({
                isStaffChecked: e.target.checked,
                isDepartmentChecked: false,
              });
            }}
            checked={radioOptionState.isStaffChecked}
          />
        </div>
        <div className="col-lg-8">
          <div className="d-flex">
            {radioOptionState.isDepartmentChecked && (
              <SelectWrapper
                className="w-100"
                placeholder="Department"
                options={props.departmentArr.map((dep) => ({
                  label: dep.departmentName,
                  value: dep.id.toString(),
                }))}
                value={selectedDepartment?.value.toString()}
                onChange={(e) => {
                  setSelectedDepartment(e);
                }}
              />
            )}
            {radioOptionState.isStaffChecked && (
              // <MultiSelectWrapper

              //   options={props.staffArr.map((staff) => {
              //     const primaryPhone = staff.phoneNumbers.find(
              //       (phone) => phone.label === "Primary"
              //     );
              //     const phoneCode = primaryPhone?.phoneCountryCode || "";
              //     const phone = primaryPhone?.phoneNumber || "";
              //     return {
              //       label: `${staff.firstName} ${staff.lastName}(${staff.email}) ${phoneCode} ${phone}`,
              //       value: staff.uuid,
              //     };
              //   })}
              //   label=""
              //   onChange={(e: any) => {
              //     setSelectedStaff(e);
              //   }}
              //   id="staff"
              //   value={selectedStaff}
              // />

              <SelectWrapper
                placeholder="Staff"
                className="w-100"
                options={props.staffArr.map((staff) => {
                  const primaryPhone = staff.phoneNumbers.find(
                    (phone) => phone.label === "Primary"
                  );
                  const phoneCode = primaryPhone?.phoneCountryCode || "";
                  const phone = primaryPhone?.phoneNumber || "";
                  return {
                    label: `${staff.firstName} ${staff.lastName}(${staff.email}) ${phoneCode} ${phone}`,
                    value: staff.uuid,
                    primaryPhone: phoneCode + phone,
                  };
                })}
                value={selectedStaff?.value}
                onChange={(e) => {
                  if (!e.primaryPhone.trim()) {
                    Swal.fire({
                      icon: "warning",
                      title: "Oops...",
                      text: "Staff phone number is missing",
                      footer:
                        '<a href="/app/staff/customers">ADD Phone Number</a>',
                    });
                  }
                  setSelectedStaff(e);
                }}
              />
            )}
            {/* <button
              className="btn btn-primary btn-sm fs-6 my-2 ms-5"
              onClick={deskphoneAssignSave}
            >
              Save
            </button> */}

            {(radioOptionState.isDepartmentChecked ||
              radioOptionState.isStaffChecked) && (
              <div className="small">
                <LoadingButton
                  btnClass="btn btn-primary btn-sm fs-6 my-2 ms-5"
                  onClick={deskphoneAssignSave}
                  minWidth="40px"
                  loading={deskphoneAssignLoading}
                >
                  Save
                </LoadingButton>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={staffNotExsistModal}
        onHide={() => {
          setStaffNotExsistModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Department</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This staff member has not been assigned to any department yet. Please
          assign the staff to department.
          <Link to="/department"> Assign Department</Link>{" "}
          {/* <Link to={`/department?redirectTo=/deskphone`}>
            {" "}
            Assign Department
          </Link>{" "} */}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};
